import { COOKIE_NAME, COOKIE_STRING } from '../../playwright/handlers'
import { SIGNED_IN_COOKIE_NAME } from '../constants'

const MOCK_SIGNED_OUT_STORAGE_KEY = 'mock-signed-out'
const MOCK_AUTH_COOKIE = `${COOKIE_STRING}; Path=/; Max-Age=${60 * 60 * 24 * 14}`

// THIS ENABLES LOGIN/LOGOUT IN THE PREVIEW PAGE.
// The MSW service worker bypasses browser navigation requests, so the /api/auth/*
// handlers in playwright/handlers.ts never see the sign-in/sign-out links —
// the SPA fallback serves index.html for those URLs instead. Emulate the auth
// endpoints at boot: sign-out clears the mock cookie (remembered for the
// session), sign-in restores it.
export function handleMockAuthNavigation() {
  // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
  const url = new URL(window.location.href)

  if (url.pathname === '/api/auth/logout') {
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    document.cookie = `${COOKIE_NAME}=; Path=/; Max-Age=0`
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    document.cookie = `${SIGNED_IN_COOKIE_NAME}=; Path=/; Max-Age=0`
    sessionStorage.setItem(MOCK_SIGNED_OUT_STORAGE_KEY, 'true')
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    window.location.replace('/login')
    return true
  }

  if (url.pathname === '/api/auth/login') {
    sessionStorage.removeItem(MOCK_SIGNED_OUT_STORAGE_KEY)
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    document.cookie = MOCK_AUTH_COOKIE
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    document.cookie = `${SIGNED_IN_COOKIE_NAME}=1; Path=/`
    // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
    window.location.replace(url.searchParams.get('redirect-path') ?? '/')
    return true
  }

  return false
}

export function setMockAuthCookieUnlessSignedOut() {
  const hasSignedOut = sessionStorage.getItem(MOCK_SIGNED_OUT_STORAGE_KEY) !== null
  if (hasSignedOut) {
    return
  }

  // eslint-disable-next-line no-restricted-properties -- outside React tree (mock setup)
  document.cookie = MOCK_AUTH_COOKIE
  console.log('Set mock auth cookie')
}
